import { type QuestionTemplateKey, questionTemplates } from "@/lib/constants/questionDefaults";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { addElement } from "@/store/slideEditorSlice";

export function useAddQuestionElement() {
  const dispatch = useAppDispatch();
  const canvasSize = useAppSelector((state) => state.slideEditor.present.canvasSize);

  const handleAddQuestionElement = (questionType: string) => {
    const template = questionTemplates[questionType as QuestionTemplateKey];

    if (template) {
      const canvasWidth = canvasSize.height * canvasSize.aspectRatio;
      const canvasHeight = canvasSize.height;
      const centeredPosition = {
        x: Math.round((canvasWidth - template.size.width) / 2),
        y: Math.round((canvasHeight - template.size.height) / 2),
      };
      dispatch(addElement({ ...template, position: centeredPosition }));
    }
  };

  return { handleAddQuestionElement };
}
